import {isReference, Reference} from "./Reference";

export interface ConstructorModel extends Reference {
}

export const isConstructorModel = (content: unknown): content is ConstructorModel => {
    return isReference(content);
}
